import React, { useMemo } from 'react';
import { TransactionStatus } from '../domain/transaction';
import { Tag } from '@chakra-ui/react';

export interface StatusBadgeProps {
  status: TransactionStatus;
  fontSize?: string;
}

export const StatusBadge = ({ status, fontSize = 's' }: StatusBadgeProps) => {

  const config = useMemo(() => {
    if (status === TransactionStatus.approved) {
      return {
        background: "success.200",
        color: "success.700",
        borderColor: "success.400",
        text: 'Aprobada',
      }
    } else if (status === TransactionStatus.rejected) {
      return {
        background: "destructive.200",
        color: "destructive.700",
        borderColor: "destructive.500",
        text: 'Rechazada',
      }
    } else if (status === TransactionStatus.reversed) {
      return {
        background: "primary.200",
        color: "primary.800",
        borderColor: "primary.500",
        text: 'Reversada',
      }
    } else {
      return {
        background: "neutral.200",
        color: "neutral.800",
        borderColor: "neutral.400",
        text: 'Error',
      }
    }
  }, [status])

  return (<Tag
    size="s"
    colorScheme="cyan"
    textTransform="capitalize"
    background={config.background}
    color={config.color}
    borderColor={config.borderColor}
    borderRadius="full"
    paddingY="s"
    paddingX="xl"
    borderWidth="normal"
    fontSize={fontSize}
  >{config.text}
  </Tag>);
};
